webpackJsonp([35783957827783],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(59);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	    var posts = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'has-text-weight-bold is-size-2' },
	            'Latest Stories'
	          )
	        ),
	        posts.filter(function (post) {
	          return post.node.frontmatter.templateKey === 'blog-post';
	        }).map(function (_ref) {
	          var post = _ref.node;
	          return _react2.default.createElement(
	            'div',
	            {
	              className: 'content',
	              style: { border: '1px solid #eaecee', padding: '2em 4em' },
	              key: post.id
	            },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'has-text-primary', to: post.fields.slug },
	                post.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' \u2022 '
	              ),
	              _react2.default.createElement(
	                'small',
	                null,
	                post.frontmatter.date
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              post.excerpt,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'button is-small', to: post.fields.slug },
	                'Keep Reading \u2192'
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  })
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-b74d135178282708c37a.js